<!-- Session validation loader - shown only during session check -->
<div *ngIf="checkingSession" class="flex flex-col items-center justify-center h-screen w-full">
    <div class="flex flex-col items-center gap-4">
        <img src="assets/logo.png" alt="Office Global Logo" class="h-[60px] object-contain">
        <p-progressspinner 
            [style]="{width: '50px', height: '50px'}" 
            strokeWidth="4"
            animationDuration=".8s"
            aria-label="Checking session">
        </p-progressspinner>
        <p class="text-base text-gray-500" i18n>Checking session...</p>
    </div>
</div>

<!-- Login form and toast - shown only after session check completes -->
<div *ngIf="!checkingSession" class="flex flex-col items-center justify-center h-screen">
    <p-toast></p-toast>
    
    <main 
        class="flex flex-col items-center justify-start border border-gray-200 rounded-lg p-10 mx-5 md:mx-0 lg:min-w-[450px]" 
        role="main">
        <img src="assets/logo.png" alt="Office Global Logo" class=" h-[60px] object-contain">
        <h1 class="text-2xl font-bold mt-2" id="login-heading" i18n>Welcome to Office Global</h1>
        <p class="text-base text-gray-500 mt-2" i18n>Enter your credentials to access your account.</p>

        <form 
            class="w-full flex flex-col items-center" 
            [formGroup]="loginForm" 
            (ngSubmit)="onSubmit()"
            aria-labelledby="login-heading"
            id="login-form">
            <div class="w-full flex flex-col gap-2 mt-5">
                <div class="w-full flex items-center justify-start">
                    <label class="text-start text-sm" for="email-input" i18n>Email</label>
                </div>
                <input 
                    pInputText 
                    formControlName="email" 
                    id="email-input"
                    i18n-placeholder
                    placeholder="e.g jacob.jhon@purple" 
                    type="email" 
                    autocomplete="email" 
                    class="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    [attr.aria-invalid]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
                    [attr.aria-describedby]="(loginForm.get('email')?.invalid && loginForm.get('email')?.touched) ? 'email-error' : null"
                    required />
                <small 
                    class="text-red-500" 
                    id="email-error"
                    role="alert"
                    *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
                    i18n>
                    Please enter a valid email address
                </small>
            </div>

            <div class="w-full flex flex-col gap-2 my-5">
                <div class="w-full flex items-center justify-between">
                    <div class="w-full flex items-center justify-start">
                        <label class="text-start text-sm" for="password-input" i18n>Password</label>
                    </div>
                    <div class="w-full flex items-center justify-end">
                        <button 
                            type="button" 
                            class="text-[#0065AE] hover:text-blue-800 text-sm cursor-pointer" 
                            (click)="onForgotPassword()"
                            i18n-aria-label
                            aria-label="Forgot your password? Click to reset"
                            i18n>
                            Forgot Password?
                        </button>
                    </div>
                </div>

                <p-password 
                    fluid 
                    formControlName="password" 
                    inputId="password-input"
                    [toggleMask]="true" 
                    i18n-placeholder
                    placeholder="••••••••" 
                    [feedback]="false" 
                    autocomplete="current-password"
                    [attr.aria-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
                    [attr.aria-describedby]="(loginForm.get('password')?.invalid && loginForm.get('password')?.touched) ? 'password-error' : null"
                    [attr.aria-required]="true">
                    <ng-template pTemplate="header">
                        <i class="pi pi-lock text-gray-500" aria-hidden="true"></i>
                    </ng-template>
                </p-password>
                <small 
                    class="text-red-500" 
                    id="password-error"
                    role="alert"
                    *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
                    i18n>
                    Password is required
                </small>
            </div>

            <p-button 
                type="submit" 
                class="w-full text-base cursor-pointer text-white rounded-lg disabled:bg-gray-400 disabled:cursor-not-allowed"
                [disabled]="loginForm.invalid || loading"
                [attr.aria-busy]="loading"
                [attr.aria-label]="loading ? 'Signing in, please wait' : 'Sign in to your account'"
                i18n-aria-label>
                <span *ngIf="!loading" i18n>Continue</span>
                <span *ngIf="loading" role="status" aria-live="polite" i18n>Loading...</span>
            </p-button>

        </form>
    </main>
</div>